// store.js

import { configureStore } from "@reduxjs/toolkit";
import loginReducer from "../features/loginSlice";
import registerReducer from "../features/registerSlice"; // Import the register reducer
import headerBannerReducer from "../features/headerBannerSlice";
import searchCategoryReducer from "../features/searchCategorySlice";
import suppotFormReducer from "../features/supportFormSlice";
import searchReducer from "../features/searchProductsSlice";
import productReducer from "../features/productSlice";
import settingReducer from "../features/settingSlice";
import productReviewReducer from "../features/productReviewSlice";
import languageReducer from "../features/languageSlice";
import getCartReducer from "../features/cartSlice";
import getCartCountReducer from "../features/getCartCountSlice";
import getWishlistReducer from "../features/getWishlistSlice";
import addressReducer from "../features/addressSlice";
import accountReducer from "../features/accountSlice";
import payStripeReducer from "../features/payStripeSlice";
import klarnaReducer from "../features/generateKlarnaSlice";
import orderReducer from "../features/placeOrderSlice";
import couponReducer from "../features/couponSlice";
import footerPagesContentReducer from "../features/footerPages/footerPagesContentSlice";

export const store = configureStore({
  reducer: {
    auth: loginReducer,
    register: registerReducer,
    banners: headerBannerReducer,
    categories: searchCategoryReducer,
    supportForm: suppotFormReducer,
    search: searchReducer,
    product: productReducer,
    setting: settingReducer,
    reviews: productReviewReducer,
    language: languageReducer,
    cart: getCartReducer,
    cartcount: getCartCountReducer,
    wishlist: getWishlistReducer,
    address: addressReducer,
    account: accountReducer,
    payStripe: payStripeReducer,
    klarna: klarnaReducer,
    order: orderReducer,
    coupon: couponReducer,
    footerPagesContent: footerPagesContentReducer,
  },
});

export default store;
